import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { postData } from "../../services/generalService";
import { PostReversalDisbursalResponseObj } from "../../utils/types";

const initialState: PostReversalDisbursalResponseObj = {
  data: null,
  isLoading: true,
  isSuccess: false,
  isError: false,
};

export const postDisbursalReversalTransaction = createAsyncThunk(
  "loans/postDisbursalReversalTransaction",
  async (formData: { url: string; postsData: {} }, thunkAPI) => {
    const { url, postsData } = formData;
    try {
      const data = await postData(url, postsData, true);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response);
    }
  }
);

const postDisbursalReversalTransactionSlice = createSlice({
  name: "postDisbursalReversalTransaction",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postDisbursalReversalTransaction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(postDisbursalReversalTransaction.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(postDisbursalReversalTransaction.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      });
  },
});

export default postDisbursalReversalTransactionSlice.reducer;
